// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useState} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import {Settings_context} from '../../settings_ctx';
import {t_use_cp} from './use_cp';
import zurl from 'zurl';
// @ts-ignore
import {code2label} from '/util/country.js';
import Icon_trash from '../../img/hola2023/icons/16/trash.svg';
import {img_url} from '../img_url';
import {Checkbox} from '../../lib/checkbox';
import {use_screen} from '../../lib/screen_util';
import {Button} from '../../../../shared/button';
import {Change_password_form} from './change_password_form';
import {Modal} from '../../../../shared/ui/modal';
import Svg_pass_changed from '../../img/cp/pass_changed_bg.svg';
import styles from './cp_settings.module.less';

type t_cp_settings_props = Partial<Pick<t_use_cp,
  'settings' | 'back_btn' | 'user_email'>>;

export const CP_settings = (props: t_cp_settings_props)=>{
    const {settings, back_btn, user_email} = props;
    const {show_privacy, favorites, allow_collect, two_step_verif,
        unsubscribed, remove_favorite, toggle_allow_collect,
        toggle_two_step_verif, toggle_unsubscribed} = settings;
    const {theme} = useContext(Settings_context);
    const [modal, set_modal] = useState('');
    const {screen} = use_screen();

    return <div className={cn(styles.content, styles.settings)}>
      <h1 className={styles.title}>{back_btn}Settings</h1>
      <section className={styles.section}>
        <h2 className={cn(styles.section_title, styles.favorite_title)}>
          Your favorite sites</h2>
        <p className={theme.p3}>Manage the list of sites you've accessed
          using Hola</p>
        {!!favorites.length && <div className={styles.favorites}>
          {favorites.map(f=>{
              const link = zurl.get_host(zurl.add_proto(f.link||'')+'/')
                  || f.name;
              const href = 'http://'+link;
              const cls = cn(styles.line, styles.favorite);
              return <a key={f.id} href={href} className={cls}>
                {f.link} <span>via</span>
                <img src={img_url(`flag/16/${f.country}.png`)}
                  alt={`${f.country}`} className="lazyload"/>
                {code2label(f.country.toUpperCase())}
                <span className={styles.remove_btn}
                  onClick={ev=>{
                    ev.preventDefault();
                    remove_favorite(f);
                  }}><Icon_trash/></span>
              </a>;
          })}
        </div>}
        <div className={cn(styles.line, styles.collect)}>
          <p className={styles.line_text}>Auto-collect favorites</p>
          <div className={styles.line_control}>
            <Checkbox mode="toggle" checked={allow_collect}
              on_change={toggle_allow_collect}/>
          </div>
        </div>
      </section>
      {show_privacy && <section className={styles.section}>
        <h2 className={styles.section_title}>Privacy</h2>
        <div className={cn(styles.line, styles.two_step_verif)}>
          <p className={styles.line_text}>2 step verification</p>
          <div className={styles.line_control}>
            <Checkbox mode="toggle" checked={two_step_verif}
              on_change={toggle_two_step_verif}/>
          </div>
        </div>
      </section>}
      <section className={styles.section}>
        <h2 className={styles.section_title}>Password</h2>
        <Button color="white" size="md" caption="Manage password"
          cls={styles.change_pass_btn} inline
          on_click={()=>set_modal('change_pass')}/>
      </section>
      <section className={styles.section}>
        <h2 className={styles.section_title}>Email subscription</h2>
        <div className={cn(styles.line, styles.allow_emails)}>
          <p className={styles.line_text}>Send me emails with news and
            promotions</p>
          <div className={styles.line_control}>
            <Checkbox mode="toggle" checked={!unsubscribed}
              on_change={toggle_unsubscribed}/>
          </div>
        </div>
      </section>
      <Modal is_open={modal == 'change_pass'} on_close={()=>set_modal(null)}
        width={screen == 'xs' ? 335 : 480} cls={styles.modal}>
        <Change_password_form on_success={()=>set_modal('change_pass_done')}
          email={user_email}/>
      </Modal>
      <Modal is_open={modal == 'change_pass_done'}
        on_close={()=>set_modal(null)} width={489} cls={styles.modal}>
        <div className={styles.password_changed}>
          <Svg_pass_changed/>
          <p className={cn(theme.bold, styles.p_title)}>
            The password for your Hola account was successfully reset
          </p>
          <p className={cn(theme.p2, styles.p_text)}>
            If you have any questions, please contact <Link
            to="/premium_support">Hola support team</Link>
          </p>
        </div>
      </Modal>
    </div>;
};
